import "./ContactPhoneFields.css";

export const CONTACT_PHONE_NOTE =
  "Optional, but helpful: school email filters sometimes hide replies from small organizations like ours. If you share a phone number, we'll only use it to follow up about this request. We won't add you to a call or text list.";

const CONTACT_PHONE_ROUTES = new Set([
  "/",
  "/home",
  "/contact",
  "/educators",
  "/careers",
  "/pilot",
  "/bootcamp",
  "/web",
]);

export const shouldShowContactPhoneFields = (route) =>
  CONTACT_PHONE_ROUTES.has(route);

export default function ContactPhoneFields() {
  return (
    <div className="form-phone-fields">
      <p className="form-phone-fields__note">
        {CONTACT_PHONE_NOTE}
      </p>
      <label className="form-phone-fields__number">
        <span>Phone number</span>
        <input autoComplete="tel" name="phone" type="tel" />
      </label>
      <div
        aria-label="Phone follow-up options"
        className="form-phone-fields__preferences"
        role="group"
      >
        <span className="form-phone-fields__preference-prompt">
          You can
        </span>
        <label>
          <input
            name="phone_contact_preference"
            type="checkbox"
            value="Call"
          />
          <span>call me</span>
        </label>
        <label>
          <input
            name="phone_contact_preference"
            type="checkbox"
            value="Text"
          />
          <span>text me</span>
        </label>
      </div>
    </div>
  );
}
